<template>
  <v-container fluid>
    <v-card
      class="mx-auto"
      max-width="600"
      outlined
    >
      <v-card-title class="pa-2 d-flex justify-space-between">
        {{ $t('connections.title') }}
        <v-btn-toggle
          v-model="connTypes"
          multiple
        >
          <v-btn rounded><v-icon>mdi-account-multiple</v-icon></v-btn>
          <v-btn rounded><v-icon>mdi-clock-outline</v-icon></v-btn>
          <v-btn rounded><v-icon>mdi-account-off-outline</v-icon></v-btn>
          <v-btn rounded><v-icon>mdi-alien-outline</v-icon></v-btn>
        </v-btn-toggle>
      </v-card-title>
      <v-card-text class="ma-0 pa-0">
        <v-list two-line class="px-2">
          <v-list-item v-for="(c, i) in filteredPersonConnections" :key="i" class="litem px-0">
            <v-list-item-icon class="my-0 py-3">
              <v-avatar :color="$store.colorizeRisk(c.risk)" size="36" class="mt-4 ml-4">
                <v-icon v-if="c.type == 'T'" class="mt-0">mdi-clock-outline</v-icon>
                <v-icon v-if="c.type == 'P'" class="mt-0">mdi-account-multiple</v-icon>
                <v-icon v-if="c.type == 'V'" class="mt-0">mdi-account-off-outline</v-icon>
                <v-icon v-if="c.type == 'F'" class="mt-0">mdi-alien-outline</v-icon>
                <!--
                <span class="white--text caption">{{c.risk}}</span>
                -->
              </v-avatar>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title class="title">{{getNickOrPid(c.pid)}}</v-list-item-title>
              <v-list-item-subtitle>
                <!--
                <v-avatar color="blue-grey" size="26" class="mr-1">
                  <span class="white--text caption">{{c.network}}</span>
                </v-avatar>
                <v-icon class="ml-2">mdi-account</v-icon>
                -->
                <v-badge
                  color="blue-grey"
                  :content="c.pstats.p"
                  class="mt-2"
                  overlap
                  v-if="c.pstats.p > 0"
                >
                  <v-icon>mdi-account-multiple</v-icon>
                </v-badge>
                <v-icon v-else class="ml-1">mdi-account-multiple</v-icon>
                <v-badge
                  color="blue-grey"
                  :content="c.pstats.t"
                  class="mt-2 ml-2"
                  overlap
                  v-if="c.pstats.t > 0"
                >
                  <v-icon>mdi-clock-outline</v-icon>
                </v-badge>
                <v-icon v-else class="ml-1">mdi-clock-outline</v-icon>
                <v-badge
                  color="blue-grey"
                  :content="c.pstats.v"
                  class="mt-2 ml-2"
                  overlap
                  v-if="c.pstats.v > 0"
                >
                  <v-icon>mdi-account-off-outline</v-icon>
                </v-badge>
                <v-icon v-else class="ml-1">mdi-account-off-outline</v-icon>
                <!--
                <v-badge
                  color="blue-grey"
                  :content="c.lstats.p + c.lstats.t + c.lstats.v"
                  class="mt-2 ml-2"
                  overlap
                >
                  <v-icon>mdi-map-marker</v-icon>
                </v-badge>
                -->
                <span class="white--text ml-2">{{formatDateDiff(c.time)}}</span>
              </v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-icon>
              <v-icon v-if="c.type == 'T'" @click="resetTime(c.pid)" class="mt-4 mr-2">mdi-eye-check-outline</v-icon>
              <v-icon @click="showEditDialog(c.pid)" class="mt-4">mdi-menu</v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
    <!-- edit dialog -->
    <v-dialog v-model="dialogEditPersonConnection" persistent max-width="350" light>
      <v-card>
        <v-card-title class="d-flex justify-space-between px-3 pt-2">
            <span>{{ $t('connections.dialogTitle')}}</span>
            <v-icon class="float-right" @click="dialogEditPersonConnection = false">mdi-close</v-icon>
        </v-card-title>
        <v-card-text>
          <v-form v-model="valid">
            <v-container>
              <v-row justify="center" align="center">
                  <v-text-field
                    v-model="formData.pid"
                    :label="$t('app.att.pid')"
                    readonly
                    required
                    disabled
                  ></v-text-field>
              </v-row>
              <v-row justify="center" align="center" class="ma-0 pa-0">
                  <v-col cols="11" class="d-flex justify-center ma-0 pa-0">
                    <v-btn-toggle
                      v-model="formData.selType"
                      mandatory
                    >
                      <v-btn rounded><v-icon>mdi-account-multiple</v-icon></v-btn>
                      <v-btn rounded><v-icon>mdi-clock-outline</v-icon></v-btn>
                      <v-btn rounded><v-icon>mdi-account-off-outline</v-icon></v-btn>
                      <v-btn rounded><v-icon>mdi-alien-outline</v-icon></v-btn>
                    </v-btn-toggle>
                  </v-col>
                  <v-col cols="1" class="pl-4 pr-0">
                    <v-icon class="ml-0" color="grey" @click="$router.push({ path: '/help/3'})">mdi-information</v-icon>
                  </v-col>
              </v-row>
              <v-row justify="center" align="center">
                  <v-text-field
                    v-model="formData.desc"
                    :counter="100"
                    :label="$t('app.att.nick')"
                  ></v-text-field>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions class="d-flex justify-space-between">
          <v-btn color="grey lighten-1" class="white--text" small @click="onDelete">{{ $t('app.btn.delete') }}</v-btn>
          <v-btn color="primary" small @click="onUpdate">{{ $t('app.btn.save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'

export default {
  name: 'Connections',
  components: {
  },
  data: () => ({
    dialogEditPersonConnection: false,
    valid: false,
    connTypes: [0,1,2,3],
    formData: {
      pid: '',
      desc: '',
      type: 0,
    }
  }),
  computed: {
    filteredPersonConnections: function() {
        var connections = []
        this.$store.getters.sortedPersonConnections.forEach(c => {
          if ((c.type === 'P' && this.connTypes.includes(0)) ||
              (c.type === 'T' && this.connTypes.includes(1)) ||
              (c.type === 'V' && this.connTypes.includes(2)) ||
              (c.type === 'F' && this.connTypes.includes(3))) {
              connections.push(c)
          }
        })
        return connections
    },
    ...mapGetters(['sortedPersonConnections', 'pid', 'nick', 'getConnTypeIndex', 'getNickOrPid']),
  },
  methods: {
    showEditDialog(pid) {
      var data = this.$store.state.data.persons.find(c => c.pid === pid)
      this.valid = false
      this.formData.pid = data.pid
      this.formData.desc = this.$store.state.nicks['' + pid]
      this.formData.selType = this.$store.getters.getConnTypeIndex(data.type)
      this.dialogEditPersonConnection = true
    },
    resetTime(pid) {
      this.$store.commit('resetTime', pid)
      this.$emit('toSynchronize')
    },
    onUpdate() {
      this.$store.dispatch('updateConnection', this.formData)
      this.dialogEditPersonConnection = false
      this.$emit('toSynchronize')
    },
    onDelete() {
      this.$store.dispatch('deleteConnection', this.formData)
      this.dialogEditPersonConnection = false
      this.$emit('toSynchronize')
    }
  }
}
</script>
<style>
.litem {
  border-top: 1px solid grey;
}
</style>
